import {get, makeUrl, post} from '../../utils/fetcher';
import {METHODS} from '../../constants';
import {setDataExport, setDataExportTypes} from '../../containers/DataExportEditForm/slice';

export function getDataExports() {
  const url = makeUrl(METHODS.GET_DATA_EXPORTS);
  return (dispatch) => get(url, dispatch)
    .then((response) => {
      if (response && response.data) {
        dispatch(setDataExport(response.data));
      }
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to get data exports:', error);
    });
}

export function createDataExport(data) {
  const url = makeUrl(METHODS.CREATE_DATA_EXPORT);
  return (dispatch) => post(url, data, dispatch)
    .then((response) => {
      if (response && response.data) {
        return response.data;
      }
      throw new Error('Empty response');
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to create data export:', error);
      throw error;
    });
}

export function getDataExportTypes() {
  const url = makeUrl(METHODS.GET_DATA_EXPORT_TYPES);
  return (dispatch) => get(url, dispatch)
    .then((response) => {
      if (response && response.data) {
        dispatch(setDataExportTypes(response.data));
      }
      return response;
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to get data exports:', error);
      throw error;
    });
}

export function deleteDataExport(id) {
  const url = makeUrl(METHODS.DELETE_DATA_EXPORT, {id});
  return (dispatch) => post(url, {}, dispatch)
    .then((response) => {
      if (response && response.success) {
        dispatch(getDataExports());
        return true;
      }
      return false;
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to delete data export:', error);
      throw error;
    });
}

export function editDataExport(data) {
  const url = makeUrl(METHODS.EDIT_DATA_EXPORT);
  return (dispatch) => post(url, data, dispatch)
    .then((response) => {
      if (response && response.data) {
        return response.data;
      }
      throw new Error('Empty response');
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to update data export:', error);
      throw error;
    });
}
